import React from "react";
import Slider from "react-slick";
import {
  SVGIcons,
  ImgIcons,
  Imgbanner,  
} from "../../Helpers/Common";

var SVGIcon = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));

export function Layout14(props) {
  
  if (props.title.display_title == "Surprise") {
      return (
      <>
        <section className="mb-0">
          <div className="temp20">
            <img src={props.title.section_layout_image} alt="DocuBay" />
          </div>
        </section>
      </>
    );
  }else{
    return (
    <>
      <section className="mb-0">
        <div className="temp12">
          <img src={props.title.section_layout_image} alt="DocuBay" />
        </div>
      </section>
    </>
  );
  }
  
}

export default Layout14;
